import type { IconTypes } from "@/components/icons/types";
import { PromoBannerMonarchProps } from "@/monarch/types/PromoBanner";
import { PromoBannerVariant } from "@/components/PromoBanner/types";

type ResolveVariantOptions = {
  sideRail?: boolean;
};

export function resolveVariant(
  data: PromoBannerMonarchProps,
  _fallbackVariant: PromoBannerVariant = "slim",
  options: ResolveVariantOptions = {},
) {
  if (data.slimV2) {
    return options.sideRail ? ("slimV2SideRail" as const) : ("slimV2" as const);
  }

  if (data.complete) {
    return "slim";
  }
  if (data.compactV2 || data.compact) return "compactPDP" as const;
  return null;
}

export function resolveProps(data: PromoBannerMonarchProps) {
  if (data.slimV2) {
    return {
      ...(data.slimV2.backgroundImage
        ? { backgroundImage: data.slimV2.backgroundImage }
        : {}),
      ...(data.slimV2.backgroundType
        ? { backgroundType: data.slimV2.backgroundType }
        : {}),
      title: data.slimV2.title,
      discountCode: data.slimV2.discountCode,
      description: data.slimV2.description,
      endDatePrefix: data.slimV2.endDatePrefix,
      endDate: data.slimV2.endDate,
      image: data.slimV2.image,
      cta: data.slimV2.cta,
      learnMoreLink: data.slimV2.learnMoreLink,
      tooltip: data.slimV2.tooltip,
    };
  }

  if (data.complete) {
    const { iconType, ...rest } = data.complete;
    return { ...rest, iconType: iconType as IconTypes | undefined };
  }

  if (data.compactV2) {
    const { iconType, ...rest } = data.compactV2;
    return { ...rest, iconType: iconType as IconTypes | undefined };
  }

  if (data.compact) {
    return { compact: data.compact };
  }

  return {};
}
